import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import * as moment from "moment";

interface VerifySignupModalProps {
  show: boolean;
  onCloseClick: () => void;
  onVerifyClick: () => void;
  onDeleteClick: () => void;
  verifying?: boolean;
  deleting?: boolean;
  user?: any;
}

const getInitials = (firstName: string | null, lastName: string | null) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
  return `${firstInitial}${lastInitial}`;
};

const VerifySignupModal: React.FC<VerifySignupModalProps> = ({
  show,
  onCloseClick,
  onVerifyClick,
  onDeleteClick,
  verifying,
  deleting,
  user,
}) => {
  return (
    <Modal isOpen={!!show} toggle={onCloseClick} centered>
      <ModalHeader toggle={onCloseClick}>Verify Signup</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 avatar-sm me-3">
              <div className="avatar-sm rounded-circle p-1">
                <div className="avatar-title bg-primary-subtle text-primary rounded-circle img-thumbnail">
                  {getInitials(user?.firstName || null, user?.lastName || null)}
                </div>
              </div>
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-0">
                {user?.firstName} {user?.lastName}
              </h6>
              <div className="text-muted">{user?.email}</div>
            </div>
          </div>
        </div>
        <div className="table-responsive border border-dashed rounded p-2">
          <table className="table table-sm table-borderless mb-0">
            <tbody>
              <tr>
                <td className="fw-semibold" style={{ width: "35%" }}>
                  Agency
                </td>
                <td>{user?.agency?.name || "Not Provided"}</td>
              </tr>
              <tr>
                <td className="fw-semibold">Role</td>
                <td>{user?.role?.name || "Not Provided"}</td>
              </tr>
              <tr>
                <td className="fw-semibold">Requested On</td>
                <td>
                  {user?.createdAt
                    ? moment(new Date(user?.createdAt)).format("DD MMM, Y")
                    : "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="light"
          className="material-shadow-none"
          onClick={onCloseClick}
          disabled={!!verifying || !!deleting}
        >
          Cancel
        </Button>
        {/* <Button
          color="danger"
          className="material-shadow-none"
          onClick={onDeleteClick}
          disabled={!!verifying || !!deleting}
        >
          {deleting ? (
            <Spinner
              color="light"
              size="sm"
              style={{ marginRight: "8px", marginBottom: "-1px" }}
            ></Spinner>
          ) : null}
          Delete User
        </Button> */}
        <Button
          color="primary"
          className="material-shadow-none"
          onClick={onVerifyClick}
          disabled={!!verifying || !!deleting}
        >
          {verifying ? (
            <Spinner
              color="light"
              size="sm"
              style={{ marginRight: "8px", marginBottom: "-1px" }}
            ></Spinner>
          ) : null}
          Verify User
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default VerifySignupModal;
